import { MdInsertLink } from 'react-icons/md';
import React from 'react';

import { useGetAnalytics, useGetEvent } from 'legacy/events/hooks';

import SettingsOption from '../SettingsOption';

interface TrackingLinksSettingsProps {
  eventId: string;
  navigateToTrackingLinks: () => void;
}

const TrackingLinksSettings: React.FC<TrackingLinksSettingsProps> = ({
  eventId,
  navigateToTrackingLinks
}) => {
  const { data: event } = useGetEvent(eventId);
  const { data: analytics } = useGetAnalytics(eventId, {
    enabled: event?.isOrganizer
  });

  return (
    <SettingsOption
      icon={<MdInsertLink size={20} />}
      title="Tracking links"
      actionLabel="Add links"
      onClick={navigateToTrackingLinks}
      value={
        analytics?.trackingLinks?.length
          ? `${analytics?.trackingLinks?.length} total`
          : ''
      }
    />
  );
};

export default TrackingLinksSettings;
